import React from "react";
import { isNil } from "lodash";
import { AiccSandboxGrading } from "types/model/aiccPromptSandbox";
import {
  GRADING_COMPARED,
  GRADING_EXPECTED,
  GRADING_FAST_PATH,
  GRADING_JACCARD,
  GRADING_JUDGE_CORRECT,
  GRADING_JUDGE_ENGAGEMENT,
  GRADING_NO,
  GRADING_NOT_RUN,
  GRADING_OUTCOME_LABEL,
  GRADING_RETRIES,
  GRADING_TITLE,
  GRADING_YES,
} from "../configs";
import styles from "../Sandbox.module.scss";

interface Props {
  grading: AiccSandboxGrading;
}

const judge = (value?: boolean) => {
  if (isNil(value)) {
    return <span className={styles.gradingNotRun}>{GRADING_NOT_RUN}</span>;
  }

  return <span className={value ? styles.gradingYes : styles.gradingNo}>{value ? GRADING_YES : GRADING_NO}</span>;
};

function GradingCard({ grading }: Props) {
  const { outcome, expected, jaccardScore, jaccardThreshold, isJaccardPassed, retryCount, maxRetries } = grading;

  return (
    <div className={styles.grading}>
      <div className={styles.gradingHead}>
        <span className={styles.gradingLabel}>{GRADING_TITLE}</span>
        <span className={styles.gradingOutcome}>{(outcome && GRADING_OUTCOME_LABEL[outcome]) || outcome}</span>
        <span className={styles.gradingDetail}>{GRADING_RETRIES(retryCount, maxRetries)}</span>
      </div>

      <div className={styles.gradingRow}>
        <span className={styles.gradingLabel}>{GRADING_EXPECTED}</span>
        <span>{expected}</span>
      </div>

      <div className={styles.gradingRow}>
        <span className={styles.gradingDetail}>{GRADING_JACCARD(jaccardScore, jaccardThreshold)}</span>
        {isJaccardPassed && <span className={styles.gradingFastPath}>{GRADING_FAST_PATH}</span>}
      </div>

      {!isJaccardPassed && (
        <div className={styles.gradingRow}>
          <span className={styles.gradingLabel}>{GRADING_JUDGE_CORRECT}</span>
          {judge(grading.llmJudgeCorrect)}
          <span className={styles.gradingLabel}>{GRADING_JUDGE_ENGAGEMENT}</span>
          {judge(grading.isGivingUp)}
        </div>
      )}

      {!!grading.processedText && (
        <div className={styles.gradingRow}>
          <span className={styles.gradingLabel}>{GRADING_COMPARED}</span>
          <span className={styles.gradingDetail}>{`${grading.processedText} · ${grading.processedExpected}`}</span>
        </div>
      )}
    </div>
  );
}

export default GradingCard;
